import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header({ user, onLogout }) {
  const location = useLocation();

  return (
    <header className="header">
      <div className="header-brand">
        <span>Mi</span> Assessment Review
      </div>
      <nav className="header-nav">
        <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
          Dashboard
        </Link>
        {user.role === 'admin' && (
          <Link to="/admin" className={location.pathname === '/admin' ? 'active' : ''}>
            Admin
          </Link>
        )}
      </nav>
      <div className="header-user">
        <span>{user.name}</span>
        <button onClick={onLogout}>Log out</button>
      </div>
    </header>
  );
}
